<template>
  <span>
    <span :style="'padding: 0pt 4pt;background-color:'+(isEdit()?'lemonchiffon':'')" 
    :contenteditable="isEdit()" 
    @input="doneEdit"
    v-html="$t(resourcekey, text, params)" :title="isEdit()?resourcekey:''" >
   </span>
    
  </span>
</template>

<script>
import usermanager from '../../usermanager';


export default {
  name:'label-editable',
  props: {
    text: [String],
    resourcekey: [String],
    for: [String],
    params: [Object]
  },

  emits: ['on-editlabel-done'],
  
  

  methods : {
    isEdit(){
      return this.resourcekey && this.$features.labelEditMode //usermanager && usermanager.isAdmin()
      //return false
    },
    doneEdit(evt) { 
      console.log("doneEdit", this.resourcekey, this.text) 
      this.$eventbus.$emit('on-editlabel-done', {resourcekey:this.resourcekey, text:evt.srcElement.innerHTML})
    }
  },

}



</script>